import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import {
  exportApi,
  metadataApi,
  pathsApi,
  scriptApi,
  segmentApi,
  summaryApi,
  videoApi,
  // v2 APIs
  videosApiV2,
  captainNapalmApi,
  promptsApi,
  xmlExportApi,
  outputApi,
} from "services/api";

export const store = configureStore({
  reducer: {
    [exportApi.reducerPath]: exportApi.reducer,
    [metadataApi.reducerPath]: metadataApi.reducer,
    [pathsApi.reducerPath]: pathsApi.reducer,
    [scriptApi.reducerPath]: scriptApi.reducer,
    [segmentApi.reducerPath]: segmentApi.reducer,
    [summaryApi.reducerPath]: summaryApi.reducer,
    [videoApi.reducerPath]: videoApi.reducer,
    // v2 API reducers
    [videosApiV2.reducerPath]: videosApiV2.reducer,
    [captainNapalmApi.reducerPath]: captainNapalmApi.reducer,
    [promptsApi.reducerPath]: promptsApi.reducer,
    [xmlExportApi.reducerPath]: xmlExportApi.reducer,
    [outputApi.reducerPath]: outputApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      exportApi.middleware,
      metadataApi.middleware,
      pathsApi.middleware,
      scriptApi.middleware,
      segmentApi.middleware,
      summaryApi.middleware,
      videoApi.middleware,
      // v2 API middleware
      videosApiV2.middleware,
      captainNapalmApi.middleware,
      promptsApi.middleware,
      xmlExportApi.middleware,
      outputApi.middleware
    ),
});

setupListeners(store.dispatch);
